export default function processIgEmbeds() {
  window.instgrm && window.instgrm.Embeds.process()
}
